import { history } from '@umijs/max';
import { Button, notification } from 'antd';
import React from 'react';

export const EMAIL_CREDIT_COST = 2;
export const PHONE_CREDIT_COST = 10;
export const PEOPLE_EMAIL_CREDIT_COST_FEATURE_KEY = 'people_email_credit_cost';
export const PEOPLE_PHONE_CREDIT_COST_FEATURE_KEY = 'people_phone_credit_cost';

const parseCreditCost = (value: unknown, fallback: number) => {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const numericValue = Number(value);
  if (!Number.isInteger(numericValue) || numericValue < 0) {
    return fallback;
  }

  return numericValue;
};

const getFeatureValue = (subscription: any, key: string) => {
  if (!Array.isArray(subscription?.subscriptionFeatures)) {
    return undefined;
  }

  return subscription.subscriptionFeatures.find(
    (subscriptionFeature: any) => subscriptionFeature?.feature?.key === key,
  )?.value;
};

export const getPeopleCreditCosts = (source?: any) => {
  const directCosts = source?.people_credit_costs || source?.peopleCreditCosts;
  const subscription = source?.subscription || source;

  return {
    email: parseCreditCost(
      directCosts?.email ?? getFeatureValue(subscription, PEOPLE_EMAIL_CREDIT_COST_FEATURE_KEY),
      EMAIL_CREDIT_COST,
    ),
    phone: parseCreditCost(
      directCosts?.phone ?? getFeatureValue(subscription, PEOPLE_PHONE_CREDIT_COST_FEATURE_KEY),
      PHONE_CREDIT_COST,
    ),
  };
};

export const getRequiredCredits = (type: string, source?: any) => {
  const costs = getPeopleCreditCosts(source);

  if (type === 'phone') return costs.phone;
  if (type === 'email' || type === 'person') return costs.email;
  return 1;
};

export const showInsufficientCreditsNotification = (
  creditsRemaining: number,
  type: string,
  requiredCredits: number,
) => {
  notification.error({
    message: `You need ${requiredCredits} ${type} credits.`,
    description: `You have ${creditsRemaining} credits remaining. Please upgrade your plan or buy more credits.`,
    placement: 'bottomRight',
    btn: React.createElement(
      Button,
      {
        style: { backgroundColor: 'black', color: 'white', borderColor: 'black' },
        onClick: () => history.push('/pricing'),
      },
      'View Plans',
    ),
  });
};

export const handlePeopleCreditError = (error: any, type: string): boolean => {
  const payload = error?.response?.data;
  if (payload?.code !== 'INSUFFICIENT_PEOPLE_CREDITS') return false;

  const creditsRemaining = Number(payload.people_credits_remaining);
  const requiredCredits = Number(payload.required_credits);
  showInsufficientCreditsNotification(
    Number.isFinite(creditsRemaining) ? creditsRemaining : 0,
    type,
    Number.isFinite(requiredCredits) ? requiredCredits : getRequiredCredits(type),
  );
  return true;
};

export const validateCredits = (creditsRemaining: number, type: string, source?: any): boolean => {
  const requiredCredits = getRequiredCredits(type, source);

  if (creditsRemaining < requiredCredits) {
    showInsufficientCreditsNotification(creditsRemaining, type, requiredCredits);

    return false;
  }
  return true;
};
